import { Spinner } from '@material-tailwind/react'
import { CompanyFilter } from '@/components/company-filter'
import { useAuthorization } from '@/hooks'
import { PageLayout } from '@/layouts/page-layout'
import { CreateButton, DownloadButton } from '@/shared/components/action-buttons'
import { LinkWithQuery } from '@/shared/components/link-with-query'
import { HasAccess } from '@permify/react-role'
import { Suspense, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Await, Link, Outlet, useLoaderData } from 'react-router-dom'
import { CompanyTable } from './tables'
import { PageLayoutError, PageLayoutOverlay } from '@/layouts'
import { create, list } from '@/router/utils'

export const CompanyList = () => {
  const { hasAccess } = useAuthorization({
    redirection: {
      enable: true
    }
  })

  const [openPopOverFilter, setOpenPopOverFilter] = useState(false)
  const { t } = useTranslation()
  const { promise } = useLoaderData()

  useEffect(() => {
    hasAccess('company#list')
  }, [])

  return (
    <PageLayout
      title={t('contractor.other')}
      actions={
        [
          <div className='flex gap gap-3' key='1'>
            <CompanyFilter
              open={openPopOverFilter}
              handler={setOpenPopOverFilter}
            />
            <LinkWithQuery to={list('companies') + '/reports'}>
              <DownloadButton />
            </LinkWithQuery>
            <HasAccess
              permissions="company#create"
              isLoading={<Spinner />}
            >

              <Link key='new_company' to={create('companies')}>
                <CreateButton />
              </Link>
            </HasAccess>
          </div>
        ]
      }
    >
      <Outlet />

      <Suspense fallback={<PageLayoutOverlay />}>
        <Await resolve={promise} errorElement={<PageLayoutError />}>
          <CompanyTable />
        </Await>
      </Suspense>

    </PageLayout>
  )
}
